import { Card } from "@components/ui-kit";
import type React from "react";
import type { FC } from "react";
import type { Project as ProjectModel } from "../../models";
import { CardTitle } from "../common";
import { StructuredBudgetItem } from "./StructuredBudgetItem";

interface ProjectProps {
  project: ProjectModel;
}

export const Project: FC<React.PropsWithChildren<ProjectProps>> = ({
  project,
}) => {
  const structuredBudgetItems = [
    ...(project.ourWorkStructured?.filter(
      (structured) => !structured.isEmpty,
    ) ?? []),
    ...(project.expensesStructured?.filter(
      (structured) => !structured.isEmpty,
    ) ?? []),
  ];

  const isProjectEmpty =
    structuredBudgetItems.find((structured) => !structured.isEmpty) ===
    undefined;

  if (isProjectEmpty) return null;

  return (
    <Card>
      <Card.Section>
        <CardTitle>{`${project.code} (${project.title})`}</CardTitle>
        <div className="divide-y">
          {structuredBudgetItems.map((item) => (
            <StructuredBudgetItem key={item.id + item.name} structured={item} />
          ))}
        </div>
      </Card.Section>
    </Card>
  );
};
